module.exports = __webpack_public_path__ + "img/boundInfo_bg.c2cc9381.png";